import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createDirectors = async (data, financer_id) => {
  const res = await axios.post(
    `${API_BASE_URL}/common`,
    { ...data, financer_id },
    { params: { table: "directors", financer_id } }
  );
  return res.data;
};
export const getAllDirectors = async (financer_id) => {
  const res = await axios.get(`${API_BASE_URL}/common`, {
    params: { table: "directors", financer_id },
  });
  return res.data;
};
export const getDirectorById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/employee/${id}`);
  return res.data;
};
export const createDirectorsLoanCapital = async (data, financer_id) => {
  const res = await axios.post(
    `${API_BASE_URL}/common`,
    { ...data, financer_id },
    { params: { table: "directors_loan_capital", financer_id } }
  );
  return res.data;
};
export const getDirectorsLoanCapitalById = async (id, financer_id) => {
  const res = await axios.get(`${API_BASE_URL}/common/${id}`, {
    params: { table: "directors_loan_capital", financer_id },
  });
  return res.data;
};

export const updateLoanCapitalById = async (id,data) => {
  const res = await axios.patch(`${API_BASE_URL}/common?table=directors_loan_capital&id=${id}`,data);
  return res.data;
};
